import React, { useState } from "react";
import "./Vendor.css";
import ReactPlayer from "react-player";
import { motion } from "framer-motion";
import { staggerChildren, slideIn } from "../../utils/motion";

const Vendor = () => {
  const [showMore, setShowMore] = useState(false);

  const benefitsText = `Why Partner with BetaHome.ng?
✅ Boost sales with flexible payment options
✅ Get paid instantly—no waiting for installments
✅ Zero risk—funding partners handle repayments
✅ Easy onboarding & support
✅ Offline furniture store purchases

Join BetaHome.ng today and help your customers furnish their homes without financial stress!`;

  const textContent = `Betahome.ng is one among the fastest growing companies in the industry with
a reputation of the best team, highly skillful, knowledgeable trained personnel. 
BetaHome.ng can be described as goal oriented, result driven and resourceful company. 
Betahome.ng trained personnel are achievers who are result driven, we are  always focused on giving positive 
return on investment. Being resourceful, this is why we can easily overcome challenges, 
as we are passionate and detail-oriented in this industry and also committed to making sure home 
is where the heart is.

As a Vendor, Betahome.ng wants to partner with your company because we are passionate about 
this industry and our quality aligns with your role, knowing that you are a forward-thinking company with a 
workplace culture where opportunities of manufacturing beautiful design as crafts exist. As a company in our team,
our skills and knowledge will be challenged and this will push us to collectively reach the hearts and homes of 
every individual with the mindset of 'home is where the heart is'.

BetaHome.ng will bring the product closer to 
the people, we will create a multi-purpose sales channel—expanding sales capacity to 
encourage volume productivity. We also create an interface between the client and manufacturer.`;

  const toggleShowMore = () => setShowMore(!showMore);

  return (
    <motion.div
      className="vendor-component"
      initial="hidden"
      whileInView="show"
      variants={staggerChildren}
      viewport={{ once: false, amount: 0.25 }}
    >
      <motion.div
        className="vendor-component-left"
        variants={slideIn("left", "tween", 0.5, 1.4)}
      >
        <h1>Become a Vendor</h1>

        {/* Always visible: benefits */}
        <p style={{ whiteSpace: "pre-line" }}>{benefitsText}</p>

        {/* Reveal long text on Learn More */}
        {showMore && (
          <p style={{ whiteSpace: "pre-line", marginTop: "15px" }}>
            {textContent}
          </p>
        )}

        {!showMore && (
          <span className="learn-more" onClick={toggleShowMore}>
            Learn More
          </span>
        )}
      </motion.div>

      <motion.div
        className="vendor-component-right"
        variants={slideIn("right", "tween", 0.5, 1.4)}
      >
        <ReactPlayer
          url="https://youtube.com/shorts/CU4C1QJRKHg?si=06YLvrgkh5ouiWyN"
          controls
          width="100%"
          height="100%"
        />
        <button
          onClick={() => window.open("https://vendor.betahome.ng", "_blank")}
          className="call-to-action-button"
        >
          Become a Vendor
        </button>
      </motion.div>
    </motion.div>
  );
};

export default Vendor;
